module.exports = __webpack_public_path__ + "img/undraw_winners_re_wr1l 1.5bae272d.png";